export default function initHeader($) {
  $('.navbar-nav .menu-item > a').addClass('nav-link fw-semibold');

  const $header = $('.site-header');
  const $menu = $('#primary-menu-wrap');
  const $toggle = $('.site-header__toggle');
  const openLabel = $toggle.data('open-label');
  const closeLabel = $toggle.data('close-label');

  if ($header.length) {
    const header = $header.get(0);
    let offsetFrame;

    const updateStickyHeaderOffset = () => {
      offsetFrame = null;
      const headerBottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));

      document.documentElement.style.setProperty('--viza-az-sticky-header-offset', `${headerBottom}px`);
    };

    const scheduleStickyHeaderOffset = () => {
      if (offsetFrame) {
        return;
      }

      offsetFrame = window.requestAnimationFrame(updateStickyHeaderOffset);
    };

    updateStickyHeaderOffset();
    window.addEventListener('scroll', scheduleStickyHeaderOffset, { passive: true });
    window.addEventListener('resize', scheduleStickyHeaderOffset);

    if ('ResizeObserver' in window) {
      const headerResizeObserver = new ResizeObserver(scheduleStickyHeaderOffset);
      headerResizeObserver.observe(header);
    }
  }

  $menu.on('show.bs.collapse', () => {
    $header.addClass('is-menu-open');
    $toggle.attr('aria-label', closeLabel);
  });

  $menu.on('hide.bs.collapse', () => {
    $header.removeClass('is-menu-open');
    $toggle.attr('aria-label', openLabel);
  });

  $menu.on('hidden.bs.collapse', () => {
    $header.removeClass('is-menu-open');
  });
}
